/**
 * Coupon type
 */
export var CouponType;
(function (CouponType) {
    /**
     * Regular coupon codes
     */
    CouponType["COUPON"] = "COUPON";
    /**
     * Special action codes
     */
    CouponType["ACTIONCODE"] = "ACTIONCODE";
})(CouponType || (CouponType = {}));
export default CouponType;
